import Axios from "../config/axios-v1-config";

export const getFleetDrivers = async () => {
  try {
    const response = await Axios.get("/fleet-drivers");
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al obtener repartidores" } };
  }
};

export const createFleetDriver = async (userData, files) => {
  const formData = new FormData();
  formData.append("userData", JSON.stringify(userData));

  if (files.dniFiles) {
    files.dniFiles.forEach((file) => formData.append("dniFiles", file));
  }
  if (files.vehicleFiles) {
    files.vehicleFiles.forEach((file) => formData.append("vehicleFiles", file));
  }
  if (files.licenseFiles) {
    files.licenseFiles.forEach((file) => formData.append("licenseFiles", file));
  }
  if (files.backgroundFiles) {
    files.backgroundFiles.forEach((file) => formData.append("backgroundFiles", file));
  }

  try {
    const response = await Axios.post("/fleet-drivers", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al crear repartidor" } };
  }
};

export const validateFleetField = async (field, value, dniType) => {
  try {
    const response = await Axios.post("/fleet-drivers/validate-field", { field, value, dniType });
    return response.data;
  } catch (error) {
    return { valid: true };
  }
};

export const activateFleetDriver = async (driverId) => {
  try {
    const response = await Axios.patch(`/fleet-drivers/${driverId}/activate`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al activar repartidor" } };
  }
};

export const deactivateFleetDriver = async (driverId) => {
  try {
    const response = await Axios.patch(`/fleet-drivers/${driverId}/deactivate`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al desactivar repartidor" } };
  }
};
